import React from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface SaleTooltipContentProps {
    actionDate: string;
    saleActionProductsAmount: number;
}

const SaleTooltipContent: React.FC<SaleTooltipContentProps> = ({ actionDate, saleActionProductsAmount }) => {
    const { t } = useTranslation();

    return (
        <>
            <Row>
                <Col>{t("createdOn", { date: actionDate })}</Col>
            </Row>
            <Row>
                <Col>{t("soldProducts", { count: saleActionProductsAmount })}</Col>
            </Row>
        </>
    );
};

export default SaleTooltipContent;
